import React from "react";

function BusinessHero({ language = "en" }) {
  return (
    <section className="hero contact-hero">
      {/* الخلفية */}
      <div
        className="hero-slides"
        style={{
          backgroundImage: "url(/img/jr5.png)",
        }}
      />

      {/* العنوان */}
      <h1>{language === "ar" ? " خدمات مكتب الجبرية لتطوير الأعمال  " : "Al-Jabriyah Business Development Services  "}</h1>

      {/* العبارات الثابتة */}
      <div className="hero-texts">
        <div className="hero-text active">
          <p>
            {/* {language === "ar"
              ? "خدمات استشارية إدارية احترافية"
              : "Professional Management Consulting Services"} */}
          </p>
          <p>
            {language === "ar"
              ? " نساعد الشركات على النمو عبر الاستراتيجية، والتوسع في الأسواق، وبناء الشراكات، ونماذج إيرادات مستدامة "
              : "We help businesses grow through strategy, market expansion, partnerships, and sustainable revenue models."}
          </p>
        </div>
      </div>

      {/* الزر */}
      <a href="#contact" className="btn">
        {language === "ar" ? " أرسل طلباً" : "SEND A REQUEST"}
      </a>

      {/* Dot واحدة (اختياري) */}
      <div className="slider-dots">
        <div className="dot active" />
      </div>
    </section>
  );
}

export default BusinessHero;
